import ModalDoubleAction from "@/app/components/ui/Modals/DoubleAction";

import {
  IRefundInitate,
  useUserBookingsRefundInitiateApI,
} from "@/app/hooks/api_hooks/bookings/useUserBookingsRefundInitiateApI";

import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useState } from "react";
import { ICancelationModalProps } from "../interface";
import { useUserBookingsRefundStatusCheckAPI } from "@/app/hooks/api_hooks/bookings/useUserBookingsRefundStatusCheckAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { BsCurrencyRupee } from "react-icons/bs";
import { useUserBookingsListAPI } from "@/app/hooks/api_hooks/bookings/useUserBookingsListApi";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

export interface IBookingRefundModalState {
  booking_id: string;
}

const RefundInitiate: React.FC<ICancelationModalProps> = () => {
  /* Instatiations */

  const modalState = useModalState("APPOINTMENT_REFUND");
  const { setInvisible } = useModalActions("APPOINTMENT_REFUND");
  const { execute: RefundInitiate } = useUserBookingsRefundInitiateApI();
  /* Instatiations Ends */

  /* API Ends */

  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { appointmentFilter, customerId, petId } = routeState.state as ICustomerProfileState;

  const [refundMessage, setRefundMessage] = useState<string | null>(null);
  const [isRefund, setIsRefund] = useState<boolean>(false);
  // const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
  const [isRefundMessage, setIsRefundMessage] = useState<string | null>(null);

  /* Redux States */
  const { booking_id } = modalState as IBookingRefundModalState;
  /* Redux States Ends */

  const { execute: fecthRefundStatus, payemtDetails } = useUserBookingsRefundStatusCheckAPI();
  const fetchCustomerBookingsAPI = useUserBookingsListAPI();
  /* Handlers / Actions Starts */

  const handleRefundInitiate = () => {
    const constructedbody: IRefundInitate = {
      booking_id: booking_id,
    };

    RefundInitiate(constructedbody).then(({ message }) => {
      setRefundMessage(message);
      setIsRefund(false);
      setIsRefundMessage(null);
      fetchCustomerBookingsAPI(customerId, petId, {
        append: false,
        filter_by: appointmentFilter.toLowerCase(),
        limit: 10,
        page: 1,
      });
    });
    // setInvisible();
  };

  const handleFetchBookingStatus = () => {
    fecthRefundStatus(booking_id).then(({ status, message }) => {
      if (status) {
        setIsRefund(false);
        // setIsButtonDisable(true);
        //
      } else {
        setIsRefund(true);
        setIsRefundMessage(message);
      }
    });
  };

  return (
    <ModalDoubleAction
      showIcon={false}
      contentOverflow={true}
      onVisibleCallback={handleFetchBookingStatus}
      modalId="APPOINTMENT_REFUND"
      button={{
        primaryButtonText: `${isRefund ? "Okay" : "Initiate Refund"}`,

        primaryButtonClassname: `bg-[#193A6A] text-white text-left  float-end`,
        secondaryButtonText: `${isRefund ? null : "Cancel"}`,
        primaryCallback: () => {
          if (isRefund) {
            setInvisible();
            setIsRefund(false);
            setIsRefundMessage(null);
            setRefundMessage(null);
          } else {
            handleRefundInitiate();
          }
        },
        shouldHideOnClick: false,
      }}
      content={
        <div>
          {isRefund ? (
            <p className="text-red-400 font-medium text-sm">{isRefundMessage}</p>
          ) : (
            <div>
              <p className="text-red-400 font-medium text-sm">{refundMessage}</p>
              <div className="flex gap-4 items-center my-4">
                <p className="w-40">Amount</p>
                <p className="text-xs font-medium flex items-center ">
                  <BsCurrencyRupee className="w-4 h-4" />
                  {payemtDetails?.refundable_amount}
                </p>
              </div>
              <div className="flex gap-4 items-center my-4">
                <p className="w-40">Mode</p>
                <p>{payemtDetails?.payment_mode}</p>
              </div>
            </div>
          )}
        </div>
      }
      title="Initiate refund back to original payment method"
      titleIcon="GrAndroid"
      titleIconClassName="text-green-500"
    />
  );
};

export default RefundInitiate;
